import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import T from '../../../app/Locale';
const DeleteUserRadio = ({ text, hint = null, currentFeedback = null, onChange }) => (_jsxs("div", { children: [_jsx("input", { type: 'radio', name: 'feedback', value: text, id: text, onChange: onChange }), _jsxs("label", Object.assign({ htmlFor: text, className: 'feedback-radio' }, { children: [T.translate('deleteUserModal.feedback.'.concat(text)), _jsx("br", {}), text.includes(currentFeedback) && (_jsx("p", { dangerouslySetInnerHTML: { __html: hint } }))] }))] }));
DeleteUserRadio.propTypes = {
    text: PropTypes.string,
    hint: PropTypes.string,
    currentFeedback: PropTypes.string,
    onChange: PropTypes.func
};
export default DeleteUserRadio;
